// extracted by mini-css-extract-plugin
export default {"agentInfoProgress":"agentInfoProgress_UJoMD","item":"item_kdaAC","title":"title_WBnu2","description":"description_bDnZZ","hasDeals":"hasDeals_jg2ZO"};